module.exports = __webpack_public_path__ + "img/ELearningLeftBanner.443b79a1.png";